import { api } from 'api';
import { call, put, SagaReturnType } from 'redux-saga/effects';
import { forecastActions } from 'store/aggregated/forecast';
import { JwtFeature } from 'utility/jwt';

import { operationWrapper } from './operationWrapper';

// Fetches forecast predictions and loads the forecast domain.
// Gated behind JwtFeature.Forecast.
export function* initializePredictions() {
  function* work(tenantId: string) {
    const { forecastDomain }: SagaReturnType<typeof api.getPredictions> =
      yield call(api.getPredictions, { tenantId });

    yield put(forecastActions.setDomain(forecastDomain));
  }

  yield call(operationWrapper, work, JwtFeature.Forecast);
}
